import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

import collectivite from './modules/Collectivite';
import support from './modules/Support';
import type from './modules/Typologie';
import show from './modules/Show';
// import user from './modules/user';

const vuexSessionStorage = new VuexPersist({
    key: 'vuex',
    storage: window.sessionStorage,
    // reducer: (state) => ({
    //
    // }),
});

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        collectivite,
        support,
        type,
        show,
        // user,
    },
    plugins: [
        vuexSessionStorage.plugin,
    ],
});



// WEBPACK FOOTER //
// ./src/store/store.js